import { CookieKey } from '@src/modules/cookie';

interface Args {
  cookie: Partial<Record<CookieKey, string>>;
  affClickId: string;
}

export const getAffClickId = ({ cookie, affClickId }: Args) => {
  const clidFromCookies = cookie?.[CookieKey.clid];
  const affClickIdFromCookies = cookie?.[CookieKey.aff_click_id];

  let resultedAffClickId = '';

  if (clidFromCookies) {
    // @todo: clidFromCookies имеет уже отформатированный вид (название|значение)
    resultedAffClickId = clidFromCookies;
  }

  if (affClickId) {
    // @todo: affClickId имеет уже отформатированный вид (название|значение)
    resultedAffClickId += `${resultedAffClickId ? '|' : ''}${affClickId}`;
  }

  if (affClickIdFromCookies) {
    resultedAffClickId += `${resultedAffClickId ? '|' : ''}affclid|${affClickIdFromCookies}`;
  }

  return resultedAffClickId;
};
